import SignupButtonDefaultProps from "segments/desktop/core-components/button/signup-button/default-props";
import YoutubePopupButtonDefaultProps from "segments/desktop/core-components/button/youtube-popup-button/default-props";

export default {
  signupButtonConfig: { ...SignupButtonDefaultProps },
  youtubePopupButtonConfig: { ...YoutubePopupButtonDefaultProps }
};
